import { useLocation, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { Bars3Icon } from '@heroicons/react/24/outline'

import styles from '../layout.module.scss'
import { ButtonBox } from './components/ButtonBox'
import { LandingMenu } from './components/LandingMenu'
import { MobileMenuDrawer } from './components/MobileMenuDrawer'
import { useAuthStatus } from '../../utils'
import { useIsMobile } from '../../hooks'

export const MainHeader = ({ ...props }) => {
	const [auth] = useAuthStatus()
	const userType = auth.user?.userType
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const isLandingMenu = pathname === `/`
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

	const isMobile = useIsMobile()

	useEffect(() => {
		if (isMobileMenuOpen) {
			document.body.style.overflow = 'hidden'
		} else {
			document.body.style.overflow = ''
		}
		return () => {
			document.body.style.overflow = ''
		}
	}, [isMobileMenuOpen])

	if (pathname.includes('/onboarding')) {
		return null
	}

	const renderBrand = () => (
		<span className={styles.headerBrand} onClick={() => navigate('/')}>
			{!isMobile ? (
				<img
					src={`/images/main_001_toplogo.png`}
					alt="SPOEUM"
					className={styles.mainLogo}
				/>
			) : (
				<img
					src={`/images/logo-ci-only.png`}
					alt="SPOEUM"
					className={styles.mainLogoMoblie}
				/>
			)}
			{auth.isAuthentication && !isMobile && (
				<span className={styles.headerType}>
					{userType === 'tourPro' ? '투어 프로' : '투어 캐디'}
				</span>
			)}
		</span>
	)

	const renderInlineButtons = () => {
		if (!auth.isAuthentication) {
			return (
				<div className={styles.headerInlineButtons}>
					<button onClick={() => navigate('/login')}>로그인</button>
					<button
						className={styles.headerInlinePrimary}
						onClick={() => navigate('/signup')}>
						회원가입
					</button>
				</div>
			)
		}

		return (
			<div className={styles.headerInlineButtons}>
				<button onClick={() => navigate('/search')}>
					{userType === 'tourPro' ? '캐디 찾기' : '프로 찾기'}
				</button>
				<button className={styles.headerInlinePrimary} onClick={() => navigate('/home')}>
					마이페이지
				</button>
			</div>
		)
	}

	return (
		<header className={styles.headerWrapper}>
			<div className={styles.header}>
				{renderBrand()}
				<div className={styles.headerLandingMenu}>
					<LandingMenu userType={userType} isLandingMenu={isLandingMenu} />
				</div>
				<div className={styles.headerActions}>
					<div className={styles.headerPrimaryButtons}>
						<ButtonBox userType={userType} />
					</div>
					{/* <div className={styles.headerInlineDesktop}>{renderInlineButtons()}</div> */}
					<button
						type="button"
						className={styles.headerHamburger}
						onClick={() => setIsMobileMenuOpen(true)}>
						<Bars3Icon />
					</button>
				</div>
			</div>

			<MobileMenuDrawer
				isOpen={isMobileMenuOpen}
				onClose={() => setIsMobileMenuOpen(false)}
			/>
		</header>
	)
}

/*
import React from 'react'


import { PencilIcon, MagnifyingGlassIcon } from '@heroicons/react/24/solid'



export const MainHeader = ({ ...props }) => {
	

	return (
		<div>
			{auth.state === 'loaded' &&
				(auth.isAuthentication ? (
					<div className={styles.header}>
						
						<div className={styles.authSection}>
							
						</div>
					</div>
				) : (
					<div className={styles.header}>
						<span
							className={styles.headerBrand}
							onClick={() => navigate('/')}>
							<img
								src={`/images/main_001_toplogo.png`}
								alt="SPOEUM"
								className={styles.mainLogo}
							/>
						</span>
						
							{pathname === `/` ? (
								<div>
									
							) : (
								''
							)}
							
						</div>
								
						
					</div>
				))}
		</div>
	)
}
*/
